import { _ as _$1 } from '@swc/helpers/esm/_object_spread.js';
import { _ } from '@swc/helpers/esm/_object_without_properties.js';
import { cx } from 'instantsearch-ui-components';
import { h } from 'preact';
import { InternalHighlight } from '../InternalHighlight/InternalHighlight.js';

function Snippet(_0) {
    var _0_classNames = _0.classNames, classNames = _0_classNames === void 0 ? {} : _0_classNames, props = _(_0, [
        "classNames"
    ]);
    return /*#__PURE__*/ h(InternalHighlight, _$1({
        classNames: {
            root: cx('ais-Snippet', classNames.root),
            highlighted: cx('ais-Snippet-highlighted', classNames.highlighted),
            nonHighlighted: cx('ais-Snippet-nonHighlighted', classNames.nonHighlighted),
            separator: cx('ais-Snippet-separator', classNames.separator)
        }
    }, props));
}

export { Snippet };
